import { GetterTree } from 'vuex';
import { AuthInterface } from './state';
import { StateInterface } from '@/interfaces/projects';


const getters: GetterTree<AuthInterface, StateInterface> = {
     getUserId( state ) {
          return state.id_usuario;
     },

     getUserType( state ) {
          return state.tipo;
     },

     getUserName( state ) {
          return state.nombre;
     },

     getKeepaliveInterval( state ) {                
          return state.keepaliveInterval;
     },

    getUserSession( state ) {                
        return {...state};
     }
}



export default getters;